var _defs, _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnbiased(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "efed21ac38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 311 137.996094 L 496 137.996094 L 496 323 L 311 323 Z M 311 137.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "785035710f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 311 616 L 496 616 L 496 671.996094 L 311 671.996094 Z M 311 616 ",
    clipRule: "nonzero"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfdf",
    d: "M 670.890625 524.6875 L 573.421875 205.785156 L 565.367188 207.28125 L 468.363281 524.6875 L 478.03125 524.6875 L 569.625 224.773438 L 661.222656 524.6875 Z M 670.890625 524.6875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfdf",
    d: "M 339.484375 579.929688 L 243.054688 264.363281 L 233.386719 264.363281 L 136.957031 579.929688 L 146.625 579.929688 L 238.222656 280.128906 L 329.816406 579.929688 Z M 339.484375 579.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfdfdf",
    d: "M 385.511719 156.410156 L 422.335938 156.410156 L 422.335938 579.929688 L 385.511719 579.929688 Z M 385.511719 156.410156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M 670.199219 143.175781 L 643.042969 148.011719 C 633.492188 161.707031 618.875 171.027344 602.535156 173.90625 L 209.570312 243.648438 C 193.113281 246.523438 176.199219 242.839844 162.621094 233.289062 L 135.347656 238.121094 C 139.835938 263.210938 163.65625 279.898438 188.742188 275.410156 L 632.914062 196.578125 C 657.886719 192.203125 674.570312 168.265625 670.199219 143.175781 Z M 670.199219 143.175781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#efed21ac38)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2c34e",
    d: "M 403.925781 137.996094 C 353.0625 137.996094 311.867188 179.199219 311.867188 230.066406 C 311.867188 280.933594 353.0625 322.136719 403.925781 322.136719 C 454.785156 322.136719 495.980469 280.933594 495.980469 230.066406 C 495.980469 179.199219 454.785156 137.996094 403.925781 137.996094 Z M 342.589844 230.066406 C 342.589844 196.117188 370.09375 168.726562 403.925781 168.726562 C 415.660156 168.726562 426.59375 171.949219 435.914062 177.703125 L 351.566406 262.058594 C 345.8125 252.738281 342.589844 241.804688 342.589844 230.066406 Z M 403.925781 291.40625 C 392.1875 291.40625 381.253906 288.183594 371.933594 282.429688 L 456.28125 198.074219 C 461.917969 207.394531 465.257812 218.328125 465.257812 230.066406 C 465.257812 264.015625 437.871094 291.40625 403.925781 291.40625 Z M 403.925781 291.40625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#785035710f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bebebe",
    d: "M 459.15625 616.757812 L 348.691406 616.757812 C 328.320312 616.757812 311.867188 633.214844 311.867188 653.582031 L 311.867188 671.996094 L 495.980469 671.996094 L 495.980469 653.582031 C 495.980469 633.214844 479.527344 616.757812 459.15625 616.757812 Z M 459.15625 616.757812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M 431.539062 579.929688 L 376.308594 579.929688 C 366.179688 579.929688 357.894531 588.214844 357.894531 598.34375 L 357.894531 616.757812 L 449.953125 616.757812 L 449.953125 598.34375 C 449.953125 588.214844 441.667969 579.929688 431.539062 579.929688 Z M 431.539062 579.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M 136.957031 579.929688 C 136.957031 600.296875 153.414062 616.757812 173.78125 616.757812 L 302.660156 616.757812 C 323.027344 616.757812 339.484375 600.296875 339.484375 579.929688 Z M 136.957031 579.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#41a08e",
    d: "M 276.886719 461.964844 C 275.734375 455.289062 271.015625 449.652344 264.574219 447.578125 L 247.425781 441.824219 L 248.347656 439.867188 C 253.757812 429.050781 256.632812 417.082031 256.632812 404.996094 C 256.632812 394.871094 248.347656 386.582031 238.222656 386.582031 C 228.09375 386.582031 219.808594 394.871094 219.808594 404.996094 C 219.808594 417.082031 222.570312 429.050781 228.09375 439.867188 L 229.015625 441.824219 L 211.871094 447.578125 C 205.425781 449.765625 200.707031 455.289062 199.558594 461.964844 L 192.191406 506.273438 L 210.605469 515.480469 L 219.808594 579.929688 L 256.632812 579.929688 L 265.839844 515.480469 L 284.25 506.273438 Z M 276.886719 461.964844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#cecece",
    d: "M 468.363281 524.6875 C 468.363281 545.058594 484.820312 561.515625 505.1875 561.515625 L 634.066406 561.515625 C 654.433594 561.515625 670.890625 545.058594 670.890625 524.6875 Z M 468.363281 524.6875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#41a08e",
    d: "M 608.289062 406.722656 C 607.140625 400.046875 602.421875 394.410156 595.976562 392.339844 L 578.832031 386.582031 L 579.753906 384.628906 C 585.160156 373.808594 588.039062 361.839844 588.039062 349.757812 C 588.039062 339.628906 579.753906 331.34375 569.625 331.34375 C 559.5 331.34375 551.214844 339.628906 551.214844 349.757812 C 551.214844 361.839844 553.976562 373.808594 559.5 384.628906 L 560.421875 386.582031 L 543.273438 392.339844 C 536.832031 394.523438 532.113281 400.046875 530.960938 406.722656 L 523.597656 451.03125 L 542.007812 460.238281 L 551.214844 524.6875 L 588.039062 524.6875 L 597.242188 460.238281 L 615.65625 451.03125 Z M 608.289062 406.722656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnbiased);
export default __webpack_public_path__ + "static/media/Unbiased.61c5ba48bdb27e7a12fc2c411ca54f2d.svg";
export { ForwardRef as ReactComponent };